import {
  DO_RESET_PHONE_NUMBER,
  GET_USER_BY_PHONE,
  SET_USER_DETAIL,
} from 'state/actionTypes';

export const getUserByPhone = payload => ({
  type: GET_USER_BY_PHONE,
  payload,
});

export const resetPhoneNumber = payload => ({
  type: DO_RESET_PHONE_NUMBER,
  payload,
});

export const setUserDetail = data => ({
  type: SET_USER_DETAIL,
  payload: { data },
});
